import { jsx as _jsx } from "react/jsx-runtime";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap';
import ReactDOM from 'react-dom/client';
import './index.css';
import { App } from "./App";
import { AppError } from "./AppError";
import { init } from "./init";
import "./i18n";
const root = ReactDOM.createRoot(document.getElementById('root'));
const err = init();
if (err) {
    root.render(_jsx(AppError, { error: err }));
}
else {
    root.render(_jsx(App, {}));
}
